import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home/index.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/category',
    name: 'Category',
    component: () => import('../views/category/index.vue'),
    meta: { title: '分类' }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/cart/index.vue'),
    meta: { title: '购物车', requireAuth: true }
  },
  {
    path: '/points-mall',
    name: 'PointsMall',
    component: () => import('../views/points-mall/index.vue'),
    meta: { title: '积分商城', requireAuth: true }
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('../views/mine/index.vue'),
    meta: { title: '我的', requireAuth: true }
  },
  {
    path: '/goods/:id',
    name: 'GoodsDetail',
    component: () => import('../views/goods-detail/index.vue'),
    meta: { title: '商品详情' }
  },
  {
    path: '/live',
    name: 'Live',
    component: () => import('../views/live/index.vue'),
    meta: { title: '直播间' }
  },
  {
    path: '/liveroom',
    name: 'LiveRoom',
    component: () => import('../views/liveroom/index.vue'),
    meta: { title: '直播间' }
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('../views/order/index.vue'),
    meta: { title: '我的订单', requireAuth: true }
  },
  {
    path: '/order/confirm',
    name: 'OrderConfirm',
    component: () => import('../views/order/confirm.vue'),
    meta: { title: '确认订单', requireAuth: true }
  },
  {
    path: '/address',
    name: 'AddressList',
    component: () => import('../views/address/list.vue'),
    meta: { title: '收货地址', requireAuth: true }
  },
  {
    path: '/address/edit',
    name: 'AddressEdit',
    component: () => import('../views/address/edit.vue'),
    meta: { title: '编辑地址', requireAuth: true }
  },
  {
    path: '/invite',
    name: 'Invite',
    component: () => import('../views/invite/index.vue'),
    meta: { title: '邀请好友' }
  },
  {
    path: '/mine/referrer-stats',
    name: 'ReferrerStats',
    component: () => import('../views/mine/referrer-stats.vue'),
    meta: { title: '推荐好友统计', requireAuth: true }
  },
  {
    path: '/mine/friends',
    name: 'Friends',
    component: () => import('../views/mine/friends.vue'),
    meta: { title: '我的好友', requireAuth: true }
  },
  {
    path: '/mine/backbone-invite',
    name: 'BackboneInvite',
    component: () => import('../views/mine/backbone-invite.vue'),
    meta: { title: '分享码' }
  },
  {
    path: '/mine/backbone-stats',
    name: 'BackboneStats',
    component: () => import('../views/mine/backbone-stats.vue'),
    meta: { title: '骨干推荐统计', requireAuth: true }
  },
  {
    path: '/logistics',
    name: 'Logistics',
    component: () => import('../views/logistics/index.vue'),
    meta: { title: '物流详情', requireAuth: true }
  },
  {
    path: '/refund',
    name: 'Refund',
    component: () => import('../views/refund/index.vue'),
    meta: { title: '我的退货', requireAuth: true }
  },
  {
    path: '/refund/apply',
    name: 'RefundApply',
    component: () => import('../views/refund/apply.vue'),
    meta: { title: '申请退货', requireAuth: true }
  },
  {
    path: '/refund/detail',
    name: 'RefundDetail',
    component: () => import('../views/refund/detail.vue'),
    meta: { title: '退货详情', requireAuth: true }
  },
  {
    path: '/refund/express',
    name: 'RefundExpress',
    component: () => import('../views/refund/express.vue'),
    meta: { title: '填写退货物流', requireAuth: true }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('../views/feedback/index.vue'),
    meta: { title: '咨询服务', requireAuth: true }
  },
  {
    path: '/complaint',
    name: 'Complaint',
    component: () => import('../views/complaint/index.vue'),
    meta: { title: '投诉建议', requireAuth: true }
  },
  {
    path: '/feedback/list',
    name: 'FeedbackList',
    component: () => import('../views/feedback/list.vue'),
    meta: { title: '咨询服务', requireAuth: true }
  },
  {
    path: '/complaint/list',
    name: 'ComplaintList',
    component: () => import('../views/complaint/list.vue'),
    meta: { title: '投诉建议', requireAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue'),
    meta: { title: '微信登录' }
  },
  {
    path: '/chat',
    name: 'ChatRoom',
    component: () => import('../views/chat/index.vue'),
    meta: { title: '社区交流', requireAuth: true }
  },
  {
    path: '/chat/admin',
    name: 'ChatAdmin',
    component: () => import('../views/chat/admin.vue'),
    meta: { title: '聊天用户管理', requireAuth: true }
  },
  {
    path: '/customer-service',
    name: 'CustomerService',
    component: () => import('../views/customer-service/index.vue'),
    meta: { title: '在线客服', requireAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 解决Vue-Router 3.x版本常见报错：重复导航+路由重定向
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 这两个错误都是路由正常流程产生的，不是bug，直接吞掉不报错
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationRedirected') {
      return // 不往外抛错误，就不会触发红屏
    }
    throw err // 其他真正的错误还是要抛出来
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    // 这两个错误都是路由正常流程产生的，不是bug，直接吞掉不报错
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationRedirected') {
      return // 不往外抛错误，就不会触发红屏
    }
    throw err // 其他真正的错误还是要抛出来
  })
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '直播带货商城'
  const token = localStorage.getItem('userToken')
  
  // 已登录用户访问登录页直接跳首页
  if (to.path === '/login' && token) {
    return next('/')
  }
  
  // 需要登录的页面校验token
  if (to.meta.requireAuth && !token) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
  
  next()
})

export default router
